import { useQuery } from "@tanstack/react-query";
import { useContext, useEffect, useState } from "react";
import { E2Data } from "../../../lib/ddd/ddd";
import LoadingDots from "../../UI/LoadingDots";
import classes from "../ServicesTable.module.scss"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import OutboxIcon from '@mui/icons-material/Outbox';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import ServicesTableTr from "./ServicesTableTr";
import { Container, Row, Col } from "react-bootstrap";
import { OrgIdContext } from "../../../store/orgId_context";
import ServicesTableTrNonEdit from "./ServicesTableTrNonEdit";
import { useTranslation } from 'react-i18next';
import InputIcon from '@mui/icons-material/Input';
import OutputIcon from '@mui/icons-material/Output';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import ServicesTableTrActivate from "./ServiceTableTrActivate";

const ddd = new E2Data("EU_AOrg_ServicesEndpoints");
ddd.format = "full";
ddd.filter = "Valid=true";

const ddd2 = new E2Data("1305b549-ffa8-11ed-9104-d391378bc95e");
ddd2.format = "full";
ddd2.filter = "Valid=true AND NonTenant=true";

const e2dataOrg = new E2Data("EU_AOrg");
e2dataOrg.format = "full";

const ServicesTable2 = ({reloadData}) => {
    const [rows, setRows] = useState([]);
    const [info, setInfo] = useState({});
    const [nonEditRows, setNonEditRows] = useState([]);
    const [masterRows, setMasterRows] = useState([]);
    const [nonEditableMasterRows, setNonEditableMasterRows] = useState([]);
    const [info2, setInfo2] = useState({});
    const { isMaintainer } = useContext(OrgIdContext);

    const [systemManaged, setSystemManaged] = useState([]);
    const [outboundNonEditable, setOutboundNonEditable] = useState([]);
    const [outboutndEditable, setOutboutndEditable] = useState([]);
    const [inboundEditable, setInboundEditable] = useState([]);
    const [inboundNonEditable, setInboundNonEditable] = useState([]);

    const { t } = useTranslation();

    const {isPending : isDataPending, data, refetch} = useQuery({
        queryKey: ['Data.GetEntityData', ddd.GetParamsObject()],
        queryFn: () => ddd.GetData()
    })

    const {isPending : isInfoPending, data : infoSrv} = useQuery({
        queryKey: ['Data.GetEntityInfo', ddd.GetParamsObject()],
        queryFn: () => ddd.GetEntityInfo()
    })

    const {isPending:orgPending, data:orgData} = useQuery({
        queryKey: ['Data.GetEntityData', e2dataOrg.GetParamsObject()],
        queryFn: () => e2dataOrg.GetData(),
    })

    /*const {isPending : isDataPending2, data: data2, refetch: refetch2} = useQuery({
        queryKey: ['Data.GetEntityData', ddd2.GetParamsObject()],
        queryFn: () => ddd2.GetData()
    })

    const {isPending : isInfoPending2, data : infoSrv2} = useQuery({
        queryKey: ['Data.GetEntityInfo', ddd2.GetParamsObject()],
        queryFn: () => ddd2.GetEntityInfo()
    })*/

    useEffect(() => {
        if(reloadData){
            refetch();
            //refetch2();
        }
    }, [reloadData]);
    
    useEffect(() => {
        if(isDataPending || isInfoPending || !data || !infoSrv)
            return;

        if(data?.result?.data){
            //setRows(data.result.data);
            splitEditAndNon(data.result.data)
        }
            
        if(infoSrv?.result?.tables && infoSrv.result.tables.length > 0)
            setInfo(infoSrv.result.tables[0]);
    }, [isDataPending, data, isInfoPending, infoSrv])

    /*useEffect(() => {
        if(isDataPending2 || isInfoPending2 || !data2 || !infoSrv2)
            return;

        if(data2?.result?.data){
            //setRows(data.result.data);
            splitEditAndNon2(data2.result.data)
        }
            
        if(infoSrv2?.result?.tables && infoSrv2.result.tables.length > 0)
            setInfo2(infoSrv2.result.tables[0]);
    }, [isDataPending2, data2, isInfoPending2, infoSrv2])*/

    const splitEditAndNon2 = (data) => {
        setNonEditableMasterRows(data);
        /*let editable = [];
        let nonEditable = [];
        for(const row of data){
            isEditable2(row) ? editable.push(row) : nonEditable.push(row);
        }

        setMasterRows(editable);
        setNonEditableMasterRows(nonEditable);*/
    }

    const splitEditAndNon = (data) => {
        //setRows(data);
        let editable = [];
        let nonEditable = [];
        let outboutndEditable = [];
        let outboundNonEditable = [];
        let systemManaged = [];
        for(const row of data){
            if(!isEditable(row) || hasEmptyArray(row)){
                systemManaged.push(row);
            }else if(specifiedNotEditable(row)){
                if(isOutbound(row))
                    outboundNonEditable.push(row)
                if(isInbound(row))
                    nonEditable.push(row);
            }else{
                if(isOutbound(row))
                    outboutndEditable.push(row)
                if(isInbound(row))
                    editable.push(row);
            }
        }

        setSystemManaged(systemManaged);
        setOutboundNonEditable(outboundNonEditable);
        setOutboutndEditable(outboutndEditable);
        setInboundEditable(editable);
        setInboundNonEditable(nonEditable);
        /*setRows(editable);
        setNonEditRows(nonEditable);*/
    }

    const isOutbound = (row) => {
        if(["Both","PushREI", "PushIEI", "Send"].indexOf(row?.ServiceEndPointCode__Direction) > -1)
            return true;
        return false;
    }

    const isInbound = (row) => {
        if(["Receive", "Both"].indexOf(row?.ServiceEndPointCode__Direction) > -1)
            return true;
        return false;
    }


    const hasEmptyArray = (row) => {
        let json = null;
        if(isMaintainer)
            json = row["ServiceEndPointCode__MaintainerUIRules"];
        if(!json)
            json = row["ServiceEndPointCode__UserUIRules"];
        if(!json) 
            return false;

        try{
            const tmp = JSON.parse(json);
            return Array.isArray(tmp);
        }catch(e){
            return false;
        }
    }

    const specifiedNotEditable = (row) => {
        return row["ServiceEndPointCode__NonCustomerEditable"] || row["NonCustomerEditable"] || false;
    }

    const isEditable = (row) =>{
        if(!row)
            return false;
        if(isMaintainer && row.ServiceEndPointCode__MaintainerUIRules && row.ServiceEndPointCode__MaintainerUIRules.length > 0 && getRulesAsArray(row.ServiceEndPointCode__MaintainerUIRules).length > 0)
            return true;
        if(row.ServiceEndPointCode__UserUIRules && row.ServiceEndPointCode__UserUIRules.length>0 && getRulesAsArray(row.ServiceEndPointCode__UserUIRules).length > 0)
            return true;

        return false;
    }

    const isEditable2 = (row) =>{
        if(!row)
            return false;

        if(isMaintainer && row.MaintainerUIRules && row.MaintainerUIRules.length > 0 && getRulesAsArray(row.MaintainerUIRules).length > 0)
            return true;
        if(row.UserUIRules && row.UserUIRules.length>0 && getRulesAsArray(row.UserUIRules).length > 0)
            return true;

        return false;
    }

    const getRulesAsArray = (str) => {
        const ret = [];
        if(!str) return ret;
        str = str.replace(/[\[\] *]/g, "");
        if(!str || str.length === 0) return ret;
        return str.split(",");
    }

    const onFormSubmit = (newData, res) =>{
        refetch();
        //refetch2();
    }

    const hasStep86 = inboundEditable?.some(item => item.ServiceEndPointCode__Step == 86) || inboundNonEditable?.some(item => item.ServiceEndPointCode__Step == 86);

    return (
        <>
        <div className={`${classes["container"]}`}>
            <div className="mb-3">
                <div style={{fontWeight:"800", marginBottom:"0.5rem"}}><OutputIcon className="me-2"/>{t("My Outbound Channels")}:</div>
                {t(`While in trial or test mode, you can use the listed electronic channels without any additional interventions.
                Before switching to the production use of one of the listed channels, you must enter the requested data (certificates, passwords, API keys etc.)`)}
            </div>
            <Container className={classes["titleContainer"]}> 
                <Row className="g-0">
                    <Col className="col-1 border">{t("Step")}</Col> 
                    <Col className="col-5 border text-start ps-3">Channel</Col>
                    <Col className="col-2 border text-start ps-3">Endpoint code</Col>
                    <Col className="col-2 border">{t("Purpose")}</Col>
                    {/* <Col className="col-1 border">{t("Direction")}</Col> */}
                    {/* <Col className="col-1 border">{t("Type")}</Col> */}
                    <Col className="col-2"></Col>
                </Row>
            </Container>
            {isDataPending && <LoadingDots/>}
            {outboutndEditable.map((row, index)=> {
                return <ServicesTableTr key={index} data={row} index={index} tableInfo={info} onSubmit={onFormSubmit} orgData={orgData?.result?.data?.[0]} refetch={refetch}/>
            })}
            {outboundNonEditable.map((row, index)=> {
                return <ServicesTableTr key={index} data={row} index={index} tableInfo={info} onSubmit={onFormSubmit} master={true} orgData={orgData?.result?.data?.[0]} refetch={refetch}/>
            })}
        </div>
        <div className={`mt-3 ${classes["container"]}`}>
            <div className="mb-3">
                <div style={{fontWeight:"800", marginBottom:"0.5rem"}}><InputIcon className="me-2"/>{t("My Inbound Channels")}:</div>
                {t(`While in trial or test mode, you can use the listed electronic channels without any additional interventions.
                Before switching to the production use of one of the listed channels, you must enter the requested data (certificates, passwords, API keys etc.)`)}
            </div>
            <Container className={classes["titleContainer"]}> 
                <Row className="g-0">
                    <Col className="col-1 border">{t("Step")}</Col> 
                    <Col className="col-5 border text-start ps-3">Channel</Col>
                    <Col className="col-2 border text-start ps-3">Endpoint code</Col>
                    <Col className="col-2 border">{t("Purpose")}</Col>
                    {/* <Col className="col-1 border">{t("Direction")}</Col> */}
                    {/* <Col className="col-1 border">{t("Type")}</Col> */}
                    <Col className="col-2"></Col>
                </Row>
            </Container>
            {isDataPending && <LoadingDots/>}
            {inboundEditable.map((row, index)=> {
                return <ServicesTableTr key={index} data={row} index={index} tableInfo={info} onSubmit={onFormSubmit} orgData={orgData?.result?.data?.[0]} refetch={refetch}/>
            })}
            {inboundNonEditable.map((row, index)=> {
                return <ServicesTableTr key={index} data={row} index={index} tableInfo={info} onSubmit={onFormSubmit} master={true} orgData={orgData?.result?.data?.[0]} refetch={refetch}/>
            })}
            {!isDataPending && !hasStep86 && <ServicesTableTrActivate key={"MailSlurp"} orgData={orgData?.result?.data?.[0]} onSubmit={() =>{refetch()}}/>}
        </div>
        <div className={`mt-3 ${classes["container"]}`}>
            <div className="mb-3">
                <div style={{fontWeight:"800", marginBottom:"0.5rem"}}><SupervisorAccountIcon className="me-2"/>{t("System managed channels")}:</div>
                {t(`You can use the listed electronic channels without any additional interventions
                (if you have the proper business package or while you are in trial or test mode).`)}
            </div>
            <Container className={classes["titleContainer"]}> 
                <Row className="g-0">
                    <Col className="col-1 border">{t("Step")}</Col> 
                    <Col className="col-5 border text-start ps-3">Channel</Col>
                    <Col className="col-2 border text-start ps-3">Endpoint code</Col>
                    <Col className="col-2 border">{t("Purpose")}</Col>
                    <Col className="col-1 border">{t("Direction")}</Col>
                    <Col className="col-1 border">{t("Type")}</Col>
                </Row>
            </Container>
            {isDataPending && <LoadingDots/>}
            {systemManaged.map((row, index)=> {
                //console.log(row);
                return <ServicesTableTrNonEdit key={index} data={row} index={index} tableInfo={info} onSubmit={onFormSubmit}/>
            })}
        </div>
        {/* <div className={`mt-3 ${classes["container"]}`}>
            <div className="mb-3">
                <div style={{fontWeight:"800"}}>{t("Electronic channels where your data entries are required")}:</div>
                {t(`While in trial or test mode, you can use the listed electronic channels without any additional interventions.
                Before switching to the production use of one of the listed channels, you must enter the requested data (certificates, passwords, API keys etc.)`)}
            </div>
            <Container className={classes["titleContainer"]}> 
                <Row className="g-0">
                    <Col className="col-1 border">{t("Step")}</Col> 
                    <Col className="col-5 border">Channel</Col>
                    <Col className="col-2 border">{t("Purpose")}</Col>
                    <Col className="col-1 border">{t("Direction")}</Col>
                    <Col className="col-1 border">{t("Type")}</Col>
                    <Col className="col-2"></Col>
                </Row>
            </Container>
            {isDataPending && <LoadingDots/>}
            {rows.map((row, index)=> {
                return <ServicesTableTr key={index} data={row} index={index} tableInfo={info} onSubmit={onFormSubmit}/>
            })}
            {masterRows.map((row, index)=> {
                return <ServicesTableTr key={index} data={row} index={index} tableInfo={info} onSubmit={onFormSubmit} master={true}/>
            })}
        </div>
        <div className={classes["container"]}>
            <div className="mb-3">
                <div style={{fontWeight:"800"}}>{t("Automatically prepared electronic distribution and interchange channels")}:</div>
                {t(`You can use the listed electronic channels without any additional interventions
                (if you have the proper business package or while you are in trial or test mode).`)}
            </div>
            <Container className={classes["titleContainer"]}> 
                <Row className="g-0">
                    <Col className="col-1 border">{t("Step")}</Col> 
                    <Col className="col-8 border">Channel</Col>
                    <Col className="col-2 border">{t("Purpose")}</Col>
                    <Col className="col-1 border">{t("Type")}</Col>
                </Row>
            </Container>
            {isDataPending && <LoadingDots/>}
            {nonEditRows.map((row, index)=> {
                //console.log(row);
                return <ServicesTableTrNonEdit key={index} data={row} index={index} tableInfo={info} onSubmit={onFormSubmit}/>
            })}
            {nonEditableMasterRows.map((row, index)=> {
                return <ServicesTableTrNonEdit key={index} data={row} index={index} tableInfo={info} onSubmit={onFormSubmit}/>
            })}
        </div> */}
        
        {false && <>
            
        <table className={`${classes["table"]} table table-striped`}>
            <thead>
                <tr className="d-flex">
                    <th className="col-2">Direction</th>
                    <th className="col-2">Service code</th>						
                    <th className="col-3">Description</th>
                    <th className="col-1">Direction</th>
                    <th className="col-1">Type</th>
                    <th className="col-1">Action</th>
                </tr>
            </thead>
            <tbody>
                
                <tr>
                    <td><OutboxIcon/></td>
                    <td><a href="#"><img src="/examples/images/avatar/1.jpg" className={`avatar`} alt="Avatar"/> Michael Holz</a></td>
                    <td>04/10/2013</td>                        
                    <td>Admin</td>
                    <td><span className={`status text-success`}><CheckCircleIcon/></span></td>
                    <td>
                        <a href="#" className={`settings`} title="Settings" data-toggle="tooltip"><i class="material-icons">&#xE8B8;</i></a>
                        <a href="#" className={`delete`} title="Delete" data-toggle="tooltip"><i class="material-icons">&#xE5C9;</i></a>
                    </td>
                </tr>
                <tr>
                    <td>2</td>
                    <td><a href="#"><img src="/examples/images/avatar/2.jpg" className={`avatar`} alt="Avatar"/> Paula Wilson</a></td>
                    <td>05/08/2014</td>                       
                    <td>Publisher</td>
                    <td><span className={`status text-success`}>&bull;</span> Active</td>
                    <td>
                        <a href="#" className={`settings`} title="Settings" data-toggle="tooltip"><i class="material-icons">&#xE8B8;</i></a>
                        <a href="#" className={`delete`} title="Delete" data-toggle="tooltip"><i class="material-icons">&#xE5C9;</i></a>
                    </td>
                </tr>
                <tr>
                    <td>2</td>
                    <td><a href="#"><img src="/examples/images/avatar/2.jpg" className={`avatar`} alt="Avatar"/> Paula Wilson</a></td>
                    <td>05/08/2014</td>                       
                    <td>Publisher</td>
                    <td><span className={`status text-success`}>&bull;</span> Active</td>
                    <td>
                        <a href="#" className={`settings`} title="Settings" data-toggle="tooltip"><i class="material-icons">&#xE8B8;</i></a>
                        <a href="#" className={`delete`} title="Delete" data-toggle="tooltip"><i class="material-icons">&#xE5C9;</i></a>
                    </td>
                </tr>
            </tbody>
        </table>
        </>}
        </>
    )
}

export default ServicesTable2;